<template>
  <b-form-group :label="properties.label">
    <div class="d-flex justify-content-start">
        <b-button
            size="sm"
            variant="primary"
            class="text-white"
            style="width: 80px;"
            @click="addRow"
          >
            Add Row
          </b-button>
    </div>
    <div class="table-container" style="overflow-x: scroll;">
        <b-table striped responsive hover :items="items" :fields="fields">
            <template #table-colgroup="scope">
                <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="field.key != 'actions' ? 'minWidth: 100px; max-width:100px;' : ''"
                >
            </template>
            <template #cell(actions)="row">
                <i @click="removeRow(row.index)" class="fa fa-trash text-danger hover-pointer" style="margin-top: 6px;"/>
            </template>
            <template #cell()="data">
                <b-form-input size="sm" :value="data.value" @input="newValue => updateCellValue(data.index, data.field.key, newValue)" ></b-form-input>
            </template>
        </b-table>
    </div>
  </b-form-group>
</template>

<script>
export default {
    name: "TableData",
    props: ["properties", "property", "value", "element"],
    methods: {
        addRow() {
            const newValue = [...this.value];
            newValue.push({});
            this.$emit("update-value", this.property, newValue);
        },
        removeRow(rowIndex) {
            const newValue = [...this.value];
            newValue.splice(rowIndex, 1);
            this.$emit("update-value", this.property, newValue);
        },
        updateCellValue(rowIndex, property, propertyNewValue) {
            const newValue = [...this.value];
            newValue[rowIndex][property] = propertyNewValue;
            this.$emit("update-value", this.property, newValue);
        }
    },
    computed: {
        fields() {
            return [
                { 
                    key: 'actions', label: '' 
                },
                ...this.element.properties.columns.map(column => ({
                    key: column.field,
                    label: column.text
                }))
            ]
        },
        items() {
            return this.value;
        }
    }
}
</script>

<style scoped>
    .table-container >>> .table th {
        border-top: none;
        white-space: nowrap;
        max-width: 100px;
        overflow-x: hidden;
        font-size: 13px;
    }
    .table-container >>> .table td {
        padding: 5px;
    }
</style>